import React from "react"
import { Component } from "react"
import axios from "axios"

class ContactForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fname: "",
      subject: "",
      email: "",
      message: "",
      info: "",
    }
  }

  render() {
    return (
      <div className="contact">
        <h2>Skontaktuj się z nami!</h2>
        <form className="form" method="POST" encType="multipart/form-data">
          <input
            type="text"
            id="fname"
            name="firstname"
            placeholder="Imie"
            value={this.state.fname}
            onChange={e => this.setState({ fname: e.target.value })}
          />

          <input
            type="text"
            id="subject"
            name="subject"
            placeholder="Temat"
            value={this.state.subject}
            onChange={e => this.setState({ subject: e.target.value })}
          />
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Email"
            value={this.state.email}
            onChange={e => this.setState({ email: e.target.value })}
          />
          <textarea
            id="message"
            name="message"
            placeholder="Wiadomość"
            onChange={e => this.setState({ message: e.target.value })}
            value={this.state.message}
          ></textarea>
          <div className="buttonSend">
            <button
              onClick={e => this.handleFormSubmit(e)}
              className="submit btn-mod btn-border btn-large"
            >
              WYŚLIJ
            </button>
            <p>{this.state.info}</p>
          </div>
        </form>
      </div>
    )
  }

  onNameChange(event) {
    this.setState({ name: event.target.value })
  }

  onEmailChange(event) {
    this.setState({ email: event.target.value })
  }

  onMessageChange(event) {
    this.setState({ message: event.target.value })
  }

  handleFormSubmit(event) {
    event.preventDefault()
    axios({
      method: "post",
      url: "https://getform.io/f/d9ed422f-e4d4-4ba3-adeb-7426c57d5898",
      data: {
        nazwa: this.state.fname,
        temat: this.state.subject,
        email: this.state.email,
        wiadomość: this.state.message,
      },
    })
      .then(r => {
        this.setState({
          fname: "",
          subject: "",
          email: "",
          message: "",
          info: "Dziękujemy!",
        })
      })
      .catch(r => {
        this.setState({
          fname: "",
          subject: "",
          email: "",
          message: "",
          info: "Coś poszło nie tak :(",
        })
      })
  }
}

export default ContactForm
